import { ApiEndpoints } from '../../../../../shared/webservices/endpoint';
import RouterUtils from '../../../../../shared/routing/RouterUtils';

export class MachineDetailRequest {

    _id; // number

    constructor() {
        this._id = -1;
    }

    setId(id) {
        this._id = id;
    }

    route() {
        return RouterUtils.generateRoute(ApiEndpoints.MACHINE_ID, { id: this._id });
    }
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/machine/form/update/machine-detail/MachineDetailRequest.js